<template>
  <div class="comp_index">
    <!-- 头部banner -->
    <img class="comp_banner1" src="static/menhu/images/pp2.webp"/>
    <!-- 品牌简述 -->
    <div class="comp_ppjs" style="background-image: url(static/menhu/images/wuxin_bg.webp)">
      <p class="comp_ppjs_title" v-html="ppData.title1"></p>
      <div class="comp_ppjs_imgdiv">
        <img class="bt_img1" src="static/menhu/images/pp3.jpg"/>
        <img class="bt_img2" src="static/logo_white.png"/>
        <!--        <p class="bt_img3">更多品牌诠释 →</p>-->
      </div>
      <p class="comp_ppjs_title" v-html="ppData.title2"></p>
    </div>

    <!-- 公司简介 -->
    <div class="comp_jj" style="background-image: url('static/menhu/images/pp4.jpg')">
      <p class="comp_jj_title">公司简介</p>
      <p class="comp_jj_desc" v-html="ppData.compjj"></p>
      <el-button @click="$router.push('comp_qs')" class="comp_jj_btn" type="info" plain>了解更多公司信息 -></el-button>
    </div>

    <!-- 公司荣誉 -->
    <div style="width: 100%;height: auto">
      <div class="simple-recent-projects">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="section-heading">
                <h2>企业荣誉</h2>
                <p>梵蒂斯在行业深耕多年，今已硕果累累，用更高的质量服务每一个客户.</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div @click.prevent="$router.push('comp_ry')" class="main-dark-button">
                <a href="#">查看更多荣誉</a>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="col-lg-12">
            <div class="projects">
              <div class="row" style="justify-content: center">
                <div class="col-lg-2" v-for="(item,index) in comRyList" :key="index">
                  <div class="project-item">
                    <div class="thumb">
                      <el-image
                        :ref="'imageRef'+index"
                        style="width: 100%;height: 240px;max-height: 240px"
                        :src="$fileDPath+item.img"
                        fit="contain"
                        :preview-src-list="[$fileDPath+item.img]"></el-image>
                      <!--                    <img :src="$fileDPath+item.img" alt="">-->
                      <div class="hover">
                        <div class="inner-content" @click="doImageClick('imageRef'+index)">
                          <h4><a style="cursor: pointer">{{ item.name }}</a></h4>
                          <!--                        <span>Construction, Building</span>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comp_index',
  data() {
    return {
      ppData: {
        title1: null,
        title2: null,
        compjj: null
      },
      comRyList: [ // 只能10个

      ],
      // 当前点击的荣誉图片

    }
  },
  created() {
    this.getCompJJ();
    this.getRY4();
  },
  methods: {
    // 获取公司简介
    getCompJJ() {
      let _this = this;
      this.$axios.get('fantis/compjj/ftCmsCompJj/queryById?id=101')
        .then(function (res) { // 请求成功 HTTP状态码是200
          if (res.data.code == 200) {
            var tempData = res.data.result;
            _this.ppData = {
              title1: tempData.compJjTitle1,
              title2: tempData.compJjTitle2,
              compjj: tempData.compJjDesc
            }
          } else {
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 获取前4个公司荣誉
    getRY4() {
      let _this = this;
      this.$axios.get('/fantis/compry/ftCmsCompRy/list?pageNo=1&pageSize=10')
        .then(function (res) { // 请求成功 HTTP状态码是200
          if (res.data.code == 200) {
            var tempData = res.data.result;

            _this.comRyList = tempData.records;
          } else {
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 点击图片
    doImageClick(ele){
      const imageElement = this.$refs[ele];
      imageElement[0].$el.__vue__.showViewer = true;
      console.dir(imageElement[0].$el.__vue__.showViewer);
    }
  }
}
</script>

<style scoped>
.comp_banner1 {
  display: block;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
}

.comp_ppjs {
  width: 100%;
  height: 98vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
}

.comp_ppjs_title {
  font-size: 24px;
  text-align: center;
  color: #000;
  font-weight: 500;
  line-height: 2;
}

.comp_ppjs_imgdiv {
  position: relative;

}

.bt_img1 {
}

.bt_img2 {
  position: absolute;
  top: 90px;
  left: 90px
}

.bt_img3 {
  position: absolute;
  top: 150px;
  left: 90px;
  font-size: 16px;
  color: rgba(8, 40, 65, 1);
  font-weight: 400;
  line-height: 1.6;
  cursor: pointer;
}

.comp_ppjs_desc {
  font-size: 16px;
  text-align: center;
  color: #666;
  line-height: 2.2;
}

.comp_jj {
  width: 100%;
  height: 96vh;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-left: 10%;
  padding-top: 5%;
}

.comp_jj_title {
  font-size: 24px;
  color: #fff;
}

.comp_jj_desc {
  font-size: 14px;
  color: #fff;
  line-height: 2.15;
  margin-bottom: 50px;
  font-weight: 300;
  width: 70%;
}

.comp_jj_btn {
  width: 238px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  color: #FFF;
  border: 1px #fff solid;
  transition: all .3s;
  -ms-transition: all .3s;
  -moz-transition: all .3s;
  -webkit-transition: all .3s;
  -o-transition: all .3s;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  justify-content: center;
  align-items: center;
}
.thumb{
  /* box-shadow: 1px 1px 12px gray; */
  padding: 10px;
  border-radius: 14px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.thumb img {
  max-height: 328px;
}

@media only screen and (max-width: 800px) {
  .bt_img2 {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 60%;
  }

  .bt_img3 {
    position: absolute;
    top: 50px;
    left: 10px;
    font-size: 16px;
    color: rgba(8, 40, 65, 1);
    font-weight: 400;
    line-height: 1.6;
    cursor: pointer;
  }

  .comp_ppjs_title {
    font-size: 14px;
  }

  .comp_jj_desc {
    font-size: 10px;
  }

  .comp_ppjs_desc {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/comp/comp_index.vue